import { useState, useRef } from "react";
import { Box, Flex, Image, useOutsideClick } from "@chakra-ui/react";
import AddEmojiIconPng from '../styles/images/add-reaction-icon.png';
import EmojiMenu from './EmojiMenu';


export default function DsrAddNewEmojiReactionButton({ messageIndex, postId, postReactions, handleAddRemoveMessageReaction }) {

  const [showEmojiMenu, setShowEmojiMenu] = useState(false);
  const [clickCount, setClickCount] = useState(0)
  const emojiMenuRef = useRef(null);

  useOutsideClick({
    ref: emojiMenuRef,
    handler: () => showEmojiMenu && (setShowEmojiMenu(false), setClickCount(prev => prev + 1)),
  });

  return (

    <Flex
      key={`emoji-menu-${clickCount}`}
      className={clickCount && "fade-in"}
      px='0.6em'
      py='0.1em'
      justify='center'
      align='center'
      rounded='0.8em'
      border="1px"
      borderColor='gray.100'
      ref={emojiMenuRef}
      cursor={(showEmojiMenu === false) ? 'pointer' : ''}
      fontSize='0.8em'
      onClick={(showEmojiMenu === false) ? () => setShowEmojiMenu(!showEmojiMenu) : null}
      _hover={!showEmojiMenu && { bg: "gray.100", color: "brandDark.500", fontWeight: "500" }}
      transition="width 0.3s ease-in-out"
      width={showEmojiMenu ? "6em" : "2.5em"}
    >

      <Box display={showEmojiMenu ? "none" : "block"} onClick={(showEmojiMenu === true) ? () => setShowEmojiMenu(!showEmojiMenu) : null} cursor={(showEmojiMenu === true) ? 'pointer' : ''}>
        <Box py='0.1em'>
          <Image src={AddEmojiIconPng} boxSize="1.3em" objectFit="cover" alt="Add Emoji Reaction" />
        </Box>
      </Box>

      {showEmojiMenu === true &&
        <Flex key={'emoji_menu_' + messageIndex}>
          <EmojiMenu
            messageIndex={messageIndex}
            postReactions={postReactions}
            handleAddRemoveMessageReaction={handleAddRemoveMessageReaction}
            postId={postId}
            setShowEmojiMenu={setShowEmojiMenu}
          />

        </Flex>}
    </Flex>

  );

}